/* @flow */

import React from 'react';
import { connect } from 'react-redux';

import * as reactGA from 'lib/analytics';

import LoadingComponent from 'components/loading';

import SubscriptionTabKycViewComponent from './view';

import Document from 'models/documents/v2/document';
import DocumentType from 'models/documents/documentType';
//import DocumentNotExpiredAndNotReplaced from 'models/documents/documentNotExpiredAndNotReplaced';

import DocumentService from 'services/DocumentService';
import RegisterService from 'services/registerService';
import { handleApiFormResponse } from 'lib/forms';

import NotificationHelper from 'lib/notifications';

import { SIGNUP_SEND_DOCUMENT } from 'constants/apiRoutes';
import {
  DOC_TYPE_ID_FRONT,
  DOC_TYPE_ID_BACK,
  DOC_TYPE_RESIDENT_BACK,
  DOC_TYPE_RESIDENT_FRONT,
  DOC_TYPE_PASSPORT,
  DOC_TYPE_ID_USERPHOTO,
  DOC_CODE_ID_USERPHOTO,
  DOC_CODE_PASSPORT,
  DOC_CODE_ID_FRONT,
  DOC_CODE_ID_BACK,
  DOC_CODE_RESIDENT_FRONT,
  DOC_CODE_RESIDENT_BACK,
  REGISTRATTION_TYPE_PASSPORT,
  REGISTRATTION_TYPE_CITIZEN,
  REGISTRATTION_TYPE_RESIDENT
} from 'constants/constants';
import { b64UrlToBlob } from 'lib/blobHelper';

type SubscriptionTabKycComponentProps = {
  activeCompanyId: number;
  successHandler: () => void;
}

type SubscriptionTabKycComponentState = {
  documents: Document[];
  isLoading: boolean;
  isProcessing: boolean;
  registrationTypeId: number;
  showExplanation: boolean;
  showMidProcessExplanation: boolean;
  takenPhoto: image;
}

class SubscriptionTabKycComponent extends React.Component<SubscriptionTabKycComponentProps, SubscriptionTabKycComponentState> {

  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      isLoading: true,
      isProcessing: false
    };
  }

  componentDidMount = async () => {
    try {
      const response = await RegisterService.getPersonInfo(this.props.activeCompanyId);

      let documents = [];

      if (response.registrationTypeId === REGISTRATTION_TYPE_PASSPORT) {
        const passportDocument = new Document();
        passportDocument.typeId = DOC_TYPE_PASSPORT;
        passportDocument.code = DOC_CODE_PASSPORT;
        passportDocument.isRequired = true;
        passportDocument.isProvided = false;
        documents.push(passportDocument);
      }

      if (response.registrationTypeId === REGISTRATTION_TYPE_CITIZEN) {
        const idDocumentFront = new Document();
        idDocumentFront.typeId = DOC_TYPE_ID_FRONT;
        idDocumentFront.code = DOC_CODE_ID_FRONT;
        idDocumentFront.isRequired = true;
        idDocumentFront.isProvided = false;
        const idDocumentBack = new Document();
        idDocumentBack.typeId = DOC_TYPE_ID_BACK;
        idDocumentBack.code = DOC_CODE_ID_BACK;
        idDocumentBack.isRequired = true;
        idDocumentBack.isProvided = false;
        documents.push(idDocumentFront);
        documents.push(idDocumentBack);
      }

      if (response.registrationTypeId === REGISTRATTION_TYPE_RESIDENT) {
        const residentDocumentFront = new Document();
        residentDocumentFront.typeId = DOC_TYPE_RESIDENT_FRONT;
        residentDocumentFront.code = DOC_CODE_RESIDENT_FRONT;
        residentDocumentFront.isRequired = true;
        residentDocumentFront.isProvided = false;
        const residentDocumentBack = new Document();
        residentDocumentBack.typeId = DOC_TYPE_RESIDENT_BACK;
        residentDocumentBack.code = DOC_CODE_RESIDENT_BACK;
        residentDocumentBack.isRequired = true;
        residentDocumentBack.isProvided = false;
        documents.push(residentDocumentFront);
        documents.push(residentDocumentBack);
      }

      const userPhotoDocument = new Document();
      userPhotoDocument.typeId = DOC_TYPE_ID_USERPHOTO;
      userPhotoDocument.code = DOC_CODE_ID_USERPHOTO;
      userPhotoDocument.isRequired = true;
      userPhotoDocument.isProvided = false;
      documents.push(userPhotoDocument);

      this.setState({
        registrationTypeId: response.registrationTypeId,
        isLoading: false,
        showExplanation: true,
        takenPhoto: null,
        documents
      });
    } catch (e) {
      console.error(e);
      NotificationHelper.createNotification(NotificationHelper.TYPE_ERROR);
    }
  }

  validateDocuments = () => {
    let isValid = true;
    const documents = this.state.documents;

    for (let i = 0; i < documents.length; i++) {
      if (documents[i].isRequired && !documents[i].isProvided && documents[i].file === null) {
        // not yet provided and missing -> issue
        documents[i].isMissing = true;
        isValid = false;
      }
    }

    if (!isValid) this.setState({ documents });
    return isValid;
  }

  handleDocumentSetPhoto = async (code: string) => {
    const documents = this.state.documents;
    let index = documents.findIndex(d => d.code === code);
    documents[index].file = await b64UrlToBlob(this.state.takenPhoto);
    documents[index].filename = documents[index].code;
    documents[index].isInvalid = false;
    documents[index].isMissing = false;
    documents[index].isProvided = true;
    document.getElementById('scrolltop')?.scrollIntoView({ behavior: 'smooth', block: "end" });
    let notProvidedDocument = documents.find(d => d.isProvided === false);
    if (notProvidedDocument === undefined)
      this.submitForm();
    else if (notProvidedDocument.typeId === DOC_TYPE_ID_USERPHOTO)
      this.setState({ documents, takenPhoto: null, showMidProcessExplanation: true });
    else
      this.setState({ documents, takenPhoto: null });
  };

  takePhoto = (image: image) => {
    document.getElementById('scrolltop')?.scrollIntoView({ behavior: 'smooth', block: "end" });
    this.setState({ takenPhoto: image });
  }

  retakePhoto = () => {
    document.getElementById('scrolltop')?.scrollIntoView({ behavior: 'smooth', block: "end" });
    this.setState({ takenPhoto: null });
  }

  submitForm = async () => {
    if (!this.validateDocuments()) return;
    this.setState({ isProcessing: true });

    // add documents
    const addPromises = [];
    this.state.documents.forEach(document => {
      if (document.file !== null) {
        addPromises.push(DocumentService.sendDocument2(SIGNUP_SEND_DOCUMENT, document.file,
          { companyId: this.props.activeCompanyId, documentTypeId: document.typeId }));
      }
    });

    // if nothing, do nothing
    if (addPromises.length === 0) {
      this.props.successHandler();
      return;
    }

    try {
      await Promise.all(addPromises);
      this.props.successHandler();
    } catch (e) {
      handleApiFormResponse.call(this, e);
      this.setState({ isProcessing: false });
    }
  }

  startKyc = () => {
    this.setState({ showExplanation: false, showMidProcessExplanation: false });
  }

  render = () => {
    if (this.state.isLoading) return (<LoadingComponent />);
    return (
      <SubscriptionTabKycViewComponent
        documents={this.state.documents}
        registrationTypeId={this.state.registrationTypeId}
        showExplanation={this.state.showExplanation}
        showMidProcessExplanation={this.state.showMidProcessExplanation}
        submitForm={this.submitForm}
        startKyc={this.startKyc}
        takePhoto={this.takePhoto}
        retakePhoto={this.retakePhoto}
        handleDocumentSetPhoto={this.handleDocumentSetPhoto}
        takenPhoto={this.state.takenPhoto}
      />
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyId: state.auth.user.activeCompany.id,
  activeCompanyPersonId: state.auth.user.activeCompany.companyPersonId
});

export default connect(mapStateToProps)(SubscriptionTabKycComponent);
